module.exports = __webpack_public_path__ + "img/202403_04.2ea878e4.jpg";